import Service from "../service";
// eslint-disable-next-line no-unused-vars

const OptionsAPI = {
  // auth
  getOptions(data) {
    if (data) {
      return Service.get(`/api/options?data=${data}`);
    } else {
      return Service.get(`/api/options?data=`);
    }
  },
  getOptionsPlant(data) {
    if (data) {
      return Service.get(`/api/optionsPlant?plant=${data}`);
    }
  },
  getOptionCommunity(data) {
    return Service.get(`/api/getOptionCommunity?id=${data}`);
  },
  getDataPlant(id) {
    return Service.get(`/api/getDataPlant?id=${id}`);
  },
  getDistrict(province_id) {
    return Service.get(`/api/options/district/` + province_id);
  },
  getSubDistrict(district_id) {
    return Service.get(`/api/options/subdistrict/` + district_id);
  },
};

export default OptionsAPI;
